import React from 'react';
import { Phone, User } from 'lucide-react';
import { Link } from 'react-router-dom';
export function TopBar() {
  return <div className="bg-[#111111] text-white py-2 px-4 md:px-8 border-b border-white/10" data-id="element-163" data-mp="2323y97ep57m0">
      <div className="max-w-7xl mx-auto flex justify-between items-center text-xs md:text-sm" data-id="element-164" data-mp="1y4vfb4lq4zjp">
        <div className="flex items-center gap-2 text-gray-300 hover:text-[#C5A55A] transition-colors" data-id="element-165" data-mp="1t5ipcazk3ccw">
          <Phone className="w-3 h-3 md:w-4 md:h-4" data-id="element-166" data-mp="2qrg6o5279bn9" />
          <a href="tel:239-810-9482" className="tracking-wide" data-id="element-167" data-mp="2quaso10v34is">
            239-810-9482
          </a>
        </div>

        <Link to="/portal" className="flex items-center gap-2 bg-[#C5A55A] hover:bg-[#D4AF37] text-black px-3 py-1.5 rounded-sm font-medium transition-colors duration-300" data-id="element-168" data-mp="2h2ergh3hayac">
          <User className="w-3 h-3 md:w-4 md:h-4" data-id="element-169" data-mp="39jhc5q9hc05n" />
          <span data-id="element-170" data-mp="39ka9y1qgnfbn">Customer Login Portal</span>
        </Link>
      </div>
    </div>;
}